const DISCLAIMER_NAMES = {
  activateMembershipAnnual: 'activate-membership-annual',
  activateMembershipSeasonal: 'activate-membership-seasonal',
  activateMembershipSeasonalPriceIncrease: 'activate-membership-seasonal-price-increase',
  gtb: 'gtb',
  gtbPriceIncrease: 'gtb-price-increase',
  gtbThankYou: 'gtb-thank-you',
  introCheckout: 'intro-checkout',
  introCheckoutPriceIncrease: 'intro-checkout-disclaimer-price-increase',
  reactivateMyMembership: 'reactivate-my-membership',
  reactivateToday1: 'reactivate-today-1',
  reactivateToday2: 'reactivate-today-2',
  refillCheckout: 'refill-checkout',
  // TO DO: replace the hardcoded values in cancel-subscription SeeDetailsModal with these consts
  // tests were failing
  upgradeToAnnualMembership: 'upgrade-to-annual-membership',
  swapForCreditAnnual: 'swap-for-credit-annual',
  swapForCreditSeasonal: 'swap-for-credit-seasonal',
  giftWithPurchaseCheckBox: 'gift-with-purchase-checkbox',
  upgradeToday: 'upgrade-today',
  upgradeToAnnualMembershipControl: 'upgrade-to-annual-membership-control',
  upgradeCartMaintained: 'upgrade-cart-maintained',
  upgradeCartDumped: 'upgrade-cart-dumped',
  customizeBoxApiError: 'customize-box-api-error',
};

export default DISCLAIMER_NAMES;
